/** @jsx jsx */
import {
  BottleImagePlaceholder,
  Box,
  Flex,
  Label,
  SemiTitle,
  Text,
} from '@bottlebooks/gatsby-design-system';
import { TastingNoteButton } from '@bottlebooks/gatsby-plugin-tastingnotes/src';
import { Button, Link } from '@bottlebooks/gatsby-theme-base/src';
import { ProductHeaderDetails } from '@bottlebooks/gatsby-theme-event/src/components/Product/ProductHeader';
import BaseProductName from '@bottlebooks/gatsby-theme-event/src/components/Product/ProductName';
import { Trans } from '@lingui/macro';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import { Wine } from 'phosphor-react';
import { jsx } from 'theme-ui';

/**
 * @param {object} props
 * @param {object} props.product
 * @param {string} props.label
 * @returns
 */
export default function ProductCard({ product, label, ...rest }) {
  const link = useLink();
  const { tastingNote, getButtonProps, getIconProps } = TastingNoteButton.use({
    productId: product.productId,
  });

  return (
    <Flex
      direction="column"
      justify="space-between"
      sx={{
        border: 1,
        borderColor: 'border',
        marginY: 2,
        padding: 2.5,
      }}
      {...rest}
    >
      <Flex
        sx={{
          height: 120,
          width: 120,
          flexShrink: 0,
          position: 'relative',
          alignSelf: 'center',
          alignItems: 'center',
          marginY: 2,
        }}
      >
        {product?.bottleImage?.fixed?.src ? (
          <img
            src={product?.bottleImage?.fixed?.src}
            sx={{
              objectFit: 'contain',
              objectPosition: 'center center',
              position: 'relative',
              width: '100%',
              height: '100%',
            }}
            alt={product?.shortName}
          />
        ) : (
          <BottleImagePlaceholder sx={{ height: 120 }} />
        )}
      </Flex>
      <Box>
        {label && <Label sx={{ marginTop: 2 }}>{label}</Label>}
        <Text variant="smallest" sx={{ marginTop: 2 }}>
          {product?.producer.name}
        </Text>
        <Link to={link.product(product)} sx={{ color: 'inherit' }}>
          <SemiTitle sx={{ paddingTop: 1, paddingBottom: 2 }}>
            <BaseProductName {...product} />
          </SemiTitle>
        </Link>
        <ProductHeaderDetails product={product} />
        {/* <Box
          sx={{
            marginTop: 2.5,
            paddingTop: 3,
            marginBottom: 2.5,
            position: 'relative',
          }}
        >
          <TastingNoteButton
            {...getButtonProps(rest)}
            sx={{ width: '100%', padding: 0 }}
          >
            <TastingNoteButton.Icon {...getIconProps()} />
            {tastingNote?.note && (
              <Text
                variant="small"
                sx={{
                  textOverflow: 'ellipsis',
                  whiteSpace: 'wrap',
                  backgroundColor: 'brand.lightGray',
                  marginTop: 2.5,
                  padding: 2,
                  position: 'relative',
                  '::before': {
                    content: '""',
                    position: 'absolute',
                    bottom: '100%',
                    left: '1.5em',
                    width: 0,
                    height: 0,
                    border: '0.75rem solid transparent',
                    borderTop: 'none',
                    borderBottomColor: 'brand.lightGray',
                  },
                }}
              >
                {tastingNote.note}
              </Text>
            )}
          </TastingNoteButton>
        </Box> */}
      </Box>
      <Button
        variant="outline"
        sx={{ display: 'flex', justifyContent: 'center', marginTop: 2.5 }}
        to={link.product(product)}
      >
        <Wine size={20} />
        <Trans>Go to product</Trans>
      </Button>
    </Flex>
  );
}
